import { useSelector } from 'react-redux';
import { DATE_FORMAT, DATE_FORMAT_ANZ, Locales } from 'constants/app.constant';
import { dateTimeHelper } from 'helpers';
import { ValidationActionType } from 'models/enum';
import { appSelectors } from 'redux/ducks/app';
import ErrorTooltip from 'components/common/error-form-field/ErrorTooltip';
import DateView from 'components/common/date/DateView';
import { ChartMetaFormField } from 'models/ui';

interface OBTriageDateFieldProps {
  formField: ChartMetaFormField;
  formSubmittedCount: number;
}

const OBTriageDateField = ({ formField, formSubmittedCount }: OBTriageDateFieldProps) => {
  const locale = useSelector(appSelectors.getLocale);
  const { name, value, disabled, isRequired, onBlur, onChange, errors = [] } = formField;
  const dateFormat = locale === Locales.EN_US ? DATE_FORMAT : DATE_FORMAT_ANZ;
  const visibleErrors = formSubmittedCount === 0 ? errors.filter((error) => error?.type !== ValidationActionType.REQUIRED) : errors;

  return (
    <div className="sng-date-container">
      <DateView
        id={name}
        value={value}
        isDisabled={disabled}
        ariaRequired={isRequired}
        placeHolder={dateFormat}
        format={dateFormat}
        formatDate={(date, format) => dateTimeHelper.datePickerFormatterWithCustomFormat(date, format)}
        parseDate={(str, format) => dateTimeHelper.datePickerParserWithCustomFormat(str, format)}
        handleDateChange={(_, v) => onChange(formField, v)}
        textFieldProps={{
          onBlur: () => onBlur(formField),
          'aria-label': name,
          'aria-required': isRequired
        }}
      />
      {visibleErrors.length > 0 && <ErrorTooltip id={`chart-field-errors-${name}`} errors={visibleErrors} formSubmittedCount={formSubmittedCount} />}
    </div>
  );
};

OBTriageDateField.displayName = 'OBTriageDateField';
export default OBTriageDateField;
